import { lazy, Suspense, useRef } from "react";
import EnterViewportAnimation from "../EnterViewportAnimation";

const LottieAnimation = lazy(() => import("./index"));

const PlayOnEnterViewport = ({ children, ...lottieProps }) => {
  const ref = useRef(null);

  return (
    <Suspense>
      <EnterViewportAnimation
        onEnter={() => {
          ref.current?.stop();
          ref.current?.play();
        }}
      >
        <LottieAnimation
          {...lottieProps}
          ref={ref}
          loop={false}
          autoplay={false}
        />
      </EnterViewportAnimation>
    </Suspense>
  );
};

export default PlayOnEnterViewport;
